import script from "./MCP_CL_004.vue?vue&type=script&setup=true&lang=js"
export * from "./MCP_CL_004.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__